import React from 'react'
import { Box } from '@mui/material';

import orgImg from '../../data/images/organization.png';
import orgImg_mobile from '../../data/images/org_mobile.png';

type Props = {}

const CompanyPage = (props: Props) => {

    const webWidth = window.innerWidth;

    return (
        <>
            <Box 
                sx={{ 
                width: '100%', 
                height: 'auto', 
                // border: '1px solid black',
                // backgroundColor: 'black',
                p: 0,
                mt: '8em',
                mb: '3em'
                }}>
                {
                    webWidth > 1300
                    ?
                    <img src={orgImg} width={'100%'} />
                    :
                    <img src={orgImg_mobile} width={'100%'} />
                }
            </Box>
        </>
    )
}

export default CompanyPage